type CountryAPIMappingType = Record<string, string>;

export const CountryAPIMapping: CountryAPIMappingType = {
  BGR: "/bg/medical-specialist",
  DEU: "/de/medical-specialist",
};
